import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Loading from "../../../../components/Loading";

const PercentuaisFinanceirosForm = ({ data, onChange, disabled }) => {
  const [formData, setFormData] = useState(data);

  useEffect(() => {
    setFormData(data);
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...formData, [name]: value };
    setFormData(updated);
    onChange({ target: { name, value } }); 
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "") return "";
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  return (
    !formData ? (
        <Loading message="Carregando dados..." />
      ) : (
        <Form>
      <Row className="mb-3">
        <Col md={3}>
          <Form.Group controlId="impostosResultadoBruto">
            <Form.Label>Impostos sobre Resultado Bruto (%)</Form.Label>
            <Form.Control
              type="number"
              name="impostosResultadoBruto"
              step="0.01"
              min="0"
              max="100"
              value={formData.impostosResultadoBruto || ""}
              onChange={handleInputChange}
              disabled={disabled}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group controlId="impostosAntesIrCsll">
            <Form.Label>Impostos antes do IR/CSLL (%)</Form.Label>
            <Form.Control
              type="number"
              name="impostosAntesIrCsll"
              step="0.01"
              min="0"
              max="100"
              value={formData.impostosAntesIrCsll || ""}
              onChange={handleInputChange}
              disabled={disabled}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group controlId="rv">
            <Form.Label>RV (%)</Form.Label>
            <Form.Control
              type="number"
              name="rv"
              step="0.01"
              min="0"
              max="100"
              value={formData.rv || ""}
              onChange={handleInputChange}
              disabled={disabled}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group controlId="despesaOperacional">
            <Form.Label>Despesa Operacional (%)</Form.Label>
            <Form.Control
              type="number"
              name="despesaOperacional"
              step="0.01"
              min="0"
              max="100"
              value={formData.despesaOperacional || ""}
              onChange={handleInputChange}
              disabled={disabled}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={3}>
          <Form.Group controlId="rateioAdministrativo">
            <Form.Label>Rateio Administrativo (%)</Form.Label>
            <Form.Control
              type="number"
              name="rateioAdministrativo"
              step="0.01"
              min="0"
              max="100"
              value={formData.rateioAdministrativo || ""}
              onChange={handleInputChange}
              disabled={disabled}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group controlId="beneficiosColaboradorSimulacao">
            <Form.Label>Valor de Benefícios e Custos em Simulações</Form.Label>
            <Form.Control
              type="currency"
              name="beneficiosColaboradorSimulacao"
              autoComplete="off"
              value={formatCurrency(formData.beneficiosColaboradorSimulacao)}
              onChange={(e) => {
                const onlyNums = e.target.value.replace(/\D/g, "");
                const numericValue = Number(onlyNums) / 100;

                const updated = { ...formData, beneficiosColaboradorSimulacao: numericValue };
                setFormData(updated);

                onChange({
                  target: { name: "beneficiosColaboradorSimulacao", value: numericValue },
                });
              }}
              disabled={disabled}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group controlId="metaTurnover">
            <Form.Label>Meta de Turnover (%)</Form.Label>
            <Form.Control
              type="number"
              name="metaTurnover"
              step="0.01"
              min="0"
              max="100"

              value={formData.metaTurnover || ""}
              onChange={handleInputChange}
              disabled={disabled}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group controlId="metaHistoricoCapacidade">
            <Form.Label>Meta de Capacidade (%)</Form.Label>
            <Form.Control
              type="number"
              name="metaCapacidade"
              step="0.01"
              min="0"
              max="100"
              value={formData.metaCapacidade || ""}              
              onChange={handleInputChange}
              disabled={disabled}
            />
          </Form.Group>
        </Col>
        
        <Col md={3}>
          <Form.Group controlId="cargoConfianca">
            <Form.Label>Cargo de Confiança (%)</Form.Label>
            <Form.Control
              type="number"
              name="cargoConfianca"
              step="0.01"
              min="0"
              max="100"
              value={formData.cargoConfianca || ""}
              onChange={handleInputChange}
              disabled={disabled}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group controlId="trienio">
            <Form.Label>Triênio (%)</Form.Label>
            <Form.Control
              type="number"
              name="trienio"
              step="0.01"
              min="0"
              max="100"
              value={formData.trienio || ""}
              onChange={handleInputChange}
              disabled={disabled}
            />
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group controlId="dataAtualizacao">
            <Form.Label>Última Atualização</Form.Label>
            <Form.Control
              type="date"
              name="dataAtualizacao"
              value={formData.dataAtualizacao?.substring(0, 10) || ""}
              readOnly
              disabled
            />
          </Form.Group>
        </Col>
      </Row>
    </Form>));
};

export default PercentuaisFinanceirosForm;